import React, { lazy } from 'react';
import EditorLoadableWrapper from '../../MuroEditorLoadableWrapper';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
const LoadableEditor = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "muro_editor" */ './Micro')));
const MicroLoadable = (props)=>{
    return /*#__PURE__*/ React.createElement(EditorLoadableWrapper, null, /*#__PURE__*/ React.createElement(LoadableEditor, props));
};
MicroLoadable.displayName = 'MicroLoadable';
export default MicroLoadable;

//# sourceMappingURL=MicroLoadable.js.map